/**
 * @file 見込み月給の変更を監視
 */
'use strict'

/**
 * @classname ChangeSalary
 * @classdesc 見込み月給の変更を監視
 */
export default class ChangeSalary {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('#expected_monthly_salary_lower')
	 * @param {jQuery} $e - $('#expected_monthly_salary_upper')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._$workingCondition = $('.working-condition')
		this._$earnMoney = $('.earn-money')
		this._$e.on('blur', () => this.onBlur())
		this.onBlur()
	}

	/**
	 * blurのコールバック
	 *
	 * @memberof ChangeSalary
	 * @description 上限見込み月給が25以上の場合は稼げるをチェック
	 * @return {undefined}
	 */
	onBlur() {
		console.log(`${this.constructor.name}.onBlur`)
		const salary = parseInt(this._$e.val());
		let earn = false;
		$('.expected_monthly_salary').each((idx, e) => {
			const salary = parseInt($(e).val());
			if(salary >= 25) {
				earn = true;
			}
		});
		if (earn) {
			this._$earnMoney.prop('checked', true);
			this._$workingCondition.css('display', 'block');
		} else {
			this._$earnMoney.prop('checked', false);
			this._$workingCondition.css('display', 'none');
		}
	}
}
